import React from "react";

export class Component extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    console.error("Boundary:", error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-[#050505] px-6 text-center">
          <div>
            <p className="font-display text-2xl text-[#D4AF37]">BAIANEIRA</p>
            <p className="mt-4 text-sm text-[#A3A3A3]">
              Qualcosa è andato storto. Ricarica la pagina.
            </p>
            <button
              data-testid="error-reload-button"
              onClick={() => window.location.reload()}
              className="mt-6 border border-[#D4AF37] px-6 py-3 text-xs tracking-[0.25em] text-[#D4AF37]"
            >
              RICARICA
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default Component;
